import { render, staticRenderFns } from "./addOwnerVotingList.vue?vue&type=template&id=2ce32929&scoped=true"
import script from "./addOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./addOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./addOwnerVotingList.vue?vue&type=style&index=0&id=2ce32929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce32929",
  null
  
)

export default component.exports